"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_hook_form_1 = require("react-hook-form");
var http_1 = __importDefault(require("../api/http"));
var apis = __importStar(require("../api/apis"));
var react_intl_1 = require("react-intl");
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        root: {
            width: '100%'
        },
        grid: {
            width: '100%',
        },
        subButton: {
            width: '100%',
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        }
    });
});
var ContactLayout = function () {
    var _a, _b, _c, _d;
    var classes = useStyles();
    var _e = react_hook_form_1.useForm(), register = _e.register, handleSubmit = _e.handleSubmit, errors = _e.errors;
    var _f = react_1.useState(false), open = _f[0], setOpen = _f[1];
    var _g = react_1.useState(false), isSubmit = _g[0], setSubmit = _g[1];
    var handleClose = function () {
        setOpen(false);
    };
    var handleOpen = function () {
        setOpen(!open);
    };
    var onSubmit = function (data, event) {
        console.log(data);
        event.preventDefault();
        handleOpen();
        http_1.default.post("" + apis.SEND_SERVICE_MAIL_API, data).then(function (res) {
            // console.log(`Respone : ${JSON.stringify(res.data)}`);
            handleClose();
            setSubmit(true);
        }).catch(function (error) {
            // console.log(`Respone Error : ${JSON.stringify(error)}`);
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !isSubmit &&
            react_1.default.createElement(core_1.Container, { maxWidth: "md" },
                react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit) },
                    react_1.default.createElement(core_1.FormControl, { fullWidth: true },
                        react_1.default.createElement(core_1.Grid, { container: true, className: classes.grid, spacing: 1 },
                            react_1.default.createElement(core_1.Grid, { container: true, item: true, xs: 12, spacing: 3 },
                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6 },
                                    react_1.default.createElement(core_1.TextField, { fullWidth: true, id: "userName", name: "userName", label: react_1.default.createElement(core_1.Typography, null,
                                            " ",
                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "userName" })), variant: "outlined", color: "secondary", inputRef: register({
                                            required: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "validationValue" }),
                                        }), error: !!errors.userName, helperText: (_a = errors.userName) === null || _a === void 0 ? void 0 : _a.message })),
                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6 },
                                    react_1.default.createElement(core_1.TextField, { fullWidth: true, id: "userMail", name: "userMail", label: react_1.default.createElement(core_1.Typography, null, "E-Mail *"), variant: "outlined", color: "secondary", inputRef: register({
                                            required: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "validationValue" }),
                                            pattern: {
                                                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                message: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "validationMail" })
                                            }
                                        }), error: !!errors.userMail, helperText: (_b = errors.userMail) === null || _b === void 0 ? void 0 : _b.message })),
                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12 },
                                    react_1.default.createElement(core_1.TextField, { fullWidth: true, id: "subject", name: "subject", label: react_1.default.createElement(core_1.Typography, null,
                                            " ",
                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "subject" })), variant: "outlined", inputRef: register({
                                            required: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "validationValue" }),
                                        }), error: !!errors.subject, helperText: (_c = errors.subject) === null || _c === void 0 ? void 0 : _c.message })),
                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12 },
                                    react_1.default.createElement(core_1.TextField, { fullWidth: true, id: "body", name: "body", label: react_1.default.createElement(core_1.Typography, null,
                                            " ",
                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "body" })), multiline: true, rows: 10, variant: "outlined", inputRef: register({
                                            required: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "validationValue" }),
                                        }), error: !!errors.body, helperText: (_d = errors.body) === null || _d === void 0 ? void 0 : _d.message })),
                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12 },
                                    react_1.default.createElement(core_1.Button, { className: classes.subButton, type: "submit", size: "large", color: "primary" },
                                        react_1.default.createElement(core_1.Typography, null,
                                            " ",
                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "send" }))))))))),
        isSubmit &&
            react_1.default.createElement(core_1.Container, { maxWidth: "md" },
                react_1.default.createElement(core_1.Typography, null,
                    " ",
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "mailResult" }))),
        react_1.default.createElement(core_1.Backdrop, { className: classes.backdrop, open: open, onClick: handleClose },
            react_1.default.createElement(core_1.CircularProgress, { color: "inherit" }))));
};
exports.default = ContactLayout;
